import PropTypes from 'prop-types';
import { Checkbox, Button, Space, Divider } from 'antd';
import styles from './styles/AdvancedTable.module.css';

const TableColumnManager = ({
  columns = [],
  visibleColumns = [],
  onToggleColumn,
  onShowAll,
  onHideAll,
  onReset,
}) => {
  return (
    <div className={styles.columnManager}>
      {/* Fixed header section */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: '1px solid #f0f0f0' }}>
        <Space wrap>
          <Button size="small" onClick={onShowAll}>
            Show All
          </Button>
          <Button size="small" onClick={onHideAll}>
            Hide All
          </Button>
          <Button size="small" onClick={onReset}>
            Reset
          </Button>
        </Space>
      </div>

      {/* Scrollable column list */}
      <div className={styles.columnList}>
        {columns.map(column => {
          const columnId = column.id || column.name;
          const isVisible = visibleColumns.includes(columnId);

          return (
            <div key={columnId} className={styles.columnItem}>
              <Checkbox checked={isVisible} onChange={() => onToggleColumn(columnId)}>
                {column.name}
              </Checkbox>
            </div>
          );
        })}
      </div>
    </div>
  );
};

TableColumnManager.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  visibleColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  onShowAll: PropTypes.func.isRequired,
  onHideAll: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default TableColumnManager;
